import React, { useCallback, useRef, useEffect, useState } from 'react';
import { FiLogIn, FiMail, FiLock, FiUser } from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
// import logo from '../../assets/logo-compressed.png';

import { logo, eventName, urlWebsite } from '../../config';
import { Container, Content, Background, AnimatedDiv2,Photo } from './styles';
import Input from '../../components/Input';
import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';

import { Pattern } from '../../styles/ThemeComponents';
import ShowDiv from '../../components/ShowOnScroll';
import Logo from '../../components/Logo';
import Whatsapp from '../../components/Whatsapp';
import { useLanguage } from '../../hooks/Language';
import api from '../../services/api';
import SelectSimple from '../../components/SelectSimple';
import UploadImage from '../../components/UploadImage';
import { FaCheck, FaCheckSquare } from 'react-icons/fa';
import Loader from '../../components/Loader';
interface SignInData {
  email: string;
  password: string;
  name: string;
}

const Profile: React.FC = () => {

  const { signIn, updateImage } = useAuth();
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);
const [loading,setLoading] = useState(false);
  const {translate} = useLanguage();

  const [student,setStudent] = useState({
    image : '/apoio/user.jpg',
    name: '',
    apelido : '',
    email : '',
    phone : '',
    extra_1 : 1
  });

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {

    const load = async () => {
     const response = await api.get('/profile');
     if(response){
       setStudent(response.data);
     }
    }
    load();

  },[])

  const handleSubmit = useCallback(
    async (data: SignInData) => {
      setLoading(true);

      const key = Object.keys(data)[0];
      if(key){ 

        if(key === 'image'){
          const formData = new FormData();
          formData.append('file', data[key]);
          const response = await api.put(`/profile/${key}`,formData);

          if(response){

            const check = setTimeout( async () => {

          
              updateImage(`${response.data.value}`);
           
                
                setStudent(state => ({ ...state, [key] : response.data.value}));
                addToast({title: 'Atualizado com sucesso!', type:"success"});
           
                setLoading(false);
                return;
              

            }, 1000);


          
          }
        }
        else{
          const response = await api.put(`/profile/${key}`,data);

          if(response){
            setStudent(state => ({ ...state, [key] : response.data.value}));
            addToast({title: 'Atualizado com sucesso!', type:"success"});
            setLoading(false);
            return;
          }
        }

  

      }

    },
    []
  );

  return (
    <Container>
      <Content>
        <AnimatedDiv2>
          {
            loading && <Loader position="absolute" message="Atualizando"/>
          }


        <Form ref={formRef} onSubmit={handleSubmit}>
        <p>Foto</p>
        
        <Photo background={student.image ? `${urlWebsite}/${student.image}` : '/apoio/user.jpg'}>
          <UploadImage placeholder="Foto" name="image"/>
          </Photo>
          <div className="checkDiv">
        <button className="checkButton" type="submit">Salvar</button></div>
        </Form>

        <Form  ref={formRef} onSubmit={handleSubmit} initialData={{apelido : student.apelido || student.name}}>
        <p style={{fontSize: '12px', textAlign: 'left', padding: '0px 10px'}}>Apelido</p>
        <div className="checkDiv">
        <Input placeholder="" type="text" name="apelido" />
        <button className="checkButton" type="submit">Salvar</button>
        </div>
        </Form>

        <Form  ref={formRef} onSubmit={handleSubmit} initialData={{apelido : student.apelido || student.name}}>
        <p style={{fontSize: '12px', textAlign: 'left', padding: '0px 10px'}}>Empresa</p>
        <div className="checkDiv">
        <Input placeholder="" type="text" name="company" />
        <button className="checkButton" type="submit">Salvar</button>
        </div>
        </Form>

        <Form  ref={formRef} onSubmit={handleSubmit} initialData={{apelido : student.apelido || student.name}}>
        <p style={{fontSize: '12px', textAlign: 'left', padding: '0px 10px'}}>Cargo</p>
        <div className="checkDiv">
        <Input placeholder="" type="text" name="position" />
        <button className="checkButton" type="submit">Salvar</button>
        </div>
        </Form>

        <Form ref={formRef} onSubmit={handleSubmit} initialData={{phone : student.phone}}>
        <p style={{fontSize: '12px', textAlign: 'left', padding: '0px 10px'}}>Telefone (WhatsApp)</p>
        <div className="checkDiv">
        <Input placeholder="" type="text" name="phone" />
        <button className="checkButton" type="submit">Salvar</button>
        </div>
        </Form>







        </AnimatedDiv2>
      </Content>
    </Container>
  );
};
export default Profile;
